<template>
  <main id="create-client-page" class="page-container">
    <form
      class="create-client-form"
      @submit.prevent="onCreateClient"
      novalidate
    >
      <!-- RIGA 1 -->
      <div class="create-client-row row-1">
        <div class="field">
          <label for="client-name">Nome cliente</label>
          <input
            id="client-name"
            type="text"
            v-model="formData.clientName"
            placeholder="inserisci il nome del cliente..."
          />
        </div>

        <div class="field">
          <label for="fiscal-code">Codice fiscale</label>
          <input
            id="fiscal-code"
            type="text"
            v-model="formData.taxCode"
            placeholder="inserisci il codice fiscale..."
          />
        </div>

        <div class="field">
          <label for="phone">Telefono</label>
          <input
            id="phone"
            type="text"
            v-model="formData.phoneNumber"
            placeholder="inserisci il numero di telefono..."
          />
        </div>
      </div>

      <!-- RIGA 2: recapito -->
      <div class="create-client-row row-2">
        <div class="field contact-selector">
          <label>Recapito preferito</label>
          <AppSelect
            v-model="contactChoice"
            :options="contactOptions"
            placeholder="— scegli —"
          />
        </div>

        <div class="field" v-if="contactChoice === 'pec'">
          <label for="pec">PEC</label>
          <input
            id="pec"
            type="email"
            v-model="formData.pec"
            required
            placeholder="inserisci l'indirizzo PEC..."
          />
        </div>

        <div class="field" v-if="contactChoice === 'email'">
          <label for="email">Email</label>
          <input
            id="email"
            type="email"
            v-model="formData.email"
            required
            placeholder="inserisci l'indirizzo email..."
          />
        </div>
      </div>

      <hr />

      <!-- RIGA 3: azienda + sede legale -->
      <div class="create-client-row row-3">
        <div class="field">
          <label for="business-name">Ragione sociale</label>
          <input
            id="business-name"
            type="text"
            v-model="formData.companyName"
            placeholder="inserisci la ragione sociale..."
            required
          />
        </div>

        <div class="field">
          <label for="vat-number">P.IVA</label>
          <input
            id="vat-number"
            type="text"
            v-model="formData.vatNumber"
            placeholder="inserisci la partita IVA..."
          />
        </div>

        <div class="field">
          <label for="unique-code">Codice univoco</label>
          <input
            id="unique-code"
            type="text"
            v-model="formData.uniqueCode"
            placeholder="inserisci il codice univoco..."
          />
        </div>

        <!-- Sede legale (autocomplete come nella CreateQuotePage) -->
        <div class="field">
          <label for="lh-address">Sede legale</label>
          <input
            type="text"
            v-model="formData.legalHeadquarters.address"
            placeholder="Inserisci l'indirizzo completo della sede legale"
            class="address-input"
          />
        </div>

        <div class="save-button-container">
          <button
            id="create-client-button"
            type="submit"
            :disabled="!canSave"
            :title="!canSave ? 'Compila i campi obbligatori' : 'Crea cliente'"
          >
            Salva
          </button>
        </div>
      </div>

      <hr />
    </form>
  </main>
</template>

<script>
import { mapActions } from "vuex/dist/vuex.cjs.js";
export default {
  name: "CreateClientPage",
  data() {
    return {
      contactChoice: "",
      // [sc-49210] Opzioni del menu a tendina
      contactOptions: [
        { value: "pec", label: "PEC" },
        { value: "email", label: "Email" },
      ],

      formData: {
        clientName: "",
        taxCode: "",
        phoneNumber: "",
        uniqueCode: "",
        companyName: "",
        vatNumber: "",
        pec: "",
        email: "",
        legalHeadquarters: {
          name: "",
          address: "",
        },
      },
      errorMessage: "",
      successMessage: "",
    };
  },
  computed: {
    isLegalAddressValid() {
      return !!(this.formData.legalHeadquarters?.address || "").trim();
    },
    canSave() {
      const hasContact =
        (this.contactChoice === "pec" && !!this.formData.pec) ||
        (this.contactChoice === "email" && !!this.formData.email);
      return (
        !!this.formData.companyName && hasContact && this.isLegalAddressValid
      );
    },
  },
  watch: {
    contactChoice(newVal) {
      if (newVal === "pec") this.formData.email = "";
      if (newVal === "email") this.formData.pec = "";
    },
  },
  methods: {
    ...mapActions(["createClient"]),

    // ---- Submit ----
    async onCreateClient() {
      try {
        this.successMessage = "";
        this.errorMessage = "";

        if (!this.contactChoice) {
          this.$toast.error("Devi selezionare un metodo di contatto.");
          return;
        }
        if (this.contactChoice === "pec" && !this.formData.pec) {
          this.$toast.error("Il campo PEC è obbligatorio.");
          return;
        }
        if (this.contactChoice === "email" && !this.formData.email) {
          this.$toast.error("Il campo Email è obbligatorio.");
          return;
        }
        if (!this.isLegalAddressValid) {
          this.$toast.error("Inserisci l'indirizzo della sede legale.");
          return;
        }
        // payload: JSON diretto, niente stringify
        const payload = { ...this.formData };
        if (this.contactChoice === "pec") delete payload.email;
        if (this.contactChoice === "email") delete payload.pec;

        const response = await this.$store.dispatch("createClient", payload);

        if (response.status === 200 || response.status === 201) {
          this.$toast.success(
            response.data?.message || "Cliente creato con successo!"
          );

          // reset form
          this.contactChoice = "";
          this.formData = {
            clientName: "",
            taxCode: "",
            phoneNumber: "",
            uniqueCode: "",
            companyName: "",
            vatNumber: "",
            pec: "",
            email: "",
            legalHeadquarters: {
              name: "",
              address: "",
            },
          };
          setTimeout(() => {
            this.$router.push({ name: "customers" });
          }, 800);
        }
      } catch (error) {
        if (error.response?.status === 409) {
          this.$toast.error(
            error.response.data?.message ||
              error.response.data?.details ||
              "Conflitto nei dati: esiste già un cliente con la stessa email e lo stesso telefono."
          );
        } else {
          this.$toast.error(
            error.response?.data?.details ||
              error.response?.data?.error ||
              "Errore durante la creazione del cliente."
          );
        }
      }
    },
  },
};
</script>

<style src="@/css/CreateClientPage.css"></style>
